export type CollaborationStatus = {
  phase: "initial" | "connecting" | "connected" | "disconnected";
  reason: "AUTH" | "PERMISSION" | "DELETED" | null;
};

export function getConnectionPresentation(status: CollaborationStatus) {
  if (status.reason === "AUTH") return { label: "인증 만료", help: "인증이 만료되어 연결이 종료되었습니다. 다시 로그인합니다.", tone: "danger", icon: "offline" } as const;
  if (status.reason === "PERMISSION") return { label: "권한 변경", help: "편집 권한 변경으로 연결이 종료되었습니다. 문서를 새로고침해 현재 권한을 확인하세요.", tone: "danger", icon: "offline" } as const;
  if (status.reason === "DELETED") return { label: "문서 종료", help: "삭제된 문서라 연결이 종료되었습니다.", tone: "danger", icon: "offline" } as const;
  if (status.phase === "connected") return { label: "연결됨", help: "실시간 공동 편집에 연결되었습니다.", tone: "success", icon: "online" } as const;
  if (status.phase === "initial") return { label: "연결 중", help: "실시간 공동 편집에 연결하고 있습니다.", tone: "warning", icon: "online" } as const;
  if (status.phase === "connecting") return { label: "재연결 중", help: "실시간 연결을 자동으로 복구하고 있습니다.", tone: "warning", icon: "retry" } as const;
  return { label: "연결 끊김", help: "연결이 끊겼습니다. 자동 재연결 중이며 계속되면 새로고침하세요.", tone: "danger", icon: "offline" } as const;
}

export const PERMISSION_SOURCE_LABELS: Record<string, string> = {
  OWNER: "개인 소유",
  USER: "직접 공유",
  USER_DENY: "이 사용자에게 명시적으로 차단됨",
  DEPT: "부서 권한",
  DEPT_HEAD: "소속 부서장 권한",
  ADMIN: "관리자 감사 권한",
  ADMIN_TRASH: "관리자 휴지통",
  HANDOVER: "인계 문서 관리자 권한",
  LEGACY_NO_OWNER: "소유자 없는 기존 문서",
  GUEST: "게스트 허용",
  NONE: "접근 권한 없음",
};

export const getPermissionReason = (source?: string | null) =>
  PERMISSION_SOURCE_LABELS[source || "NONE"] || PERMISSION_SOURCE_LABELS.NONE;
